
    <div class="card" *ngIf="!loading">
        <div class="card-header">
            <h1 class="text-center"  [appMath]="'Show Syllabus ' +syllabus.syllabus_code"></h1>
            <table class='table'>
             <tr>
              <td>Total Template Count</td>
              <td>{{syllabus.totalTemplateCount}}</td>
            </tr>
            <tr>
              <td>Standard Template Count</td>
              <td><a [routerLink]="['/admin/syllabus/taskTemplates','STANDARD',syllabus.syllabuscode]"> {{syllabus.standardTemplateCount}} </a></td></tr>
             <tr>
              <td>Trivial Template Count</td>
              <td><a [routerLink]="['/admin/syllabus/taskTemplates','TRIVIAL',syllabus.syllabuscode]">{{syllabus.trivialTemplateCount}}</a></td></tr>
             <tr><td>Answer Template Count</td><td>{{syllabus.answerTemplateCount}}</td></tr>
             <tr><td>Fact Count</td>{{syllabus.factCount}}<td></td></tr>
            </table>

        </div>
        <div class="card-body">
            <ul *ngFor="let topic of syllabus.topics;">
                <li class="alert alert-info"><a [routerLink]="['/admin/topic/show',topic.id]">{{topic.name}}[{{topic.questionTemplateCount}}][{{topic.answerTemplateCount}}][facts={{topic.factCount}}]</a></li>
                  <table class="table  table-striped">
                    <tbody>

                    <tr *ngFor="let subtopic of topic.subtopics;">
                      <td>
                      <a [routerLink]="['/admin/subtopic/show',subtopic.id]">
                      <i *ngIf="subtopic.questionTemplateCount == 0" class='fa fa-square'></i>
                      <i *ngIf="subtopic.questionTemplateCount > 0" class='fa fa-square-o'></i>
                      <span *ngIf="subtopic.is_open!=1" class="text-danger">Premium</span>
                     [<i>{{subtopic.subtopiccode}}</i>] <span [innerHTML]="subtopic.name">

                      </span> [{{subtopic.questionTemplateCount}}][{{subtopic.answerTemplateCount}}] [facts={{subtopic.factCount}}]
                      </a>
                      </td>
                      <td></td>

                  </tr>
                  </tbody>
                    </table>


            </ul>

            <app-admin-syllabus-add-topic [syllabus]="syllabus" (addNewTopicFinished)="reloadTopic()"> </app-admin-syllabus-add-topic>
        </div>

        <div class="card-body alert alert-info">
          <div class="text-center"> Subjects</div>
          <table class="table table-compressed">
            <thead>
              <tr>
                <th> Name</th>
                <th> Country</th>
                <th> Level</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let subject of syllabus.subjects;">
                <td>{{subject.name}}</td>
                <td>{{subject.syllabuscode}}</td>
                <td>{{subject.level}}</td>

            </tr>
            </tbody>

        </table>
      </div>
        <div class="card-footer">
            <fieldset class="buttons text-center alert">
                <a [routerLink]="['/home/admin/show']" class="edit btn btn-primary me-3">
                  <i class="fa fa-home"></i>  Close
                </a>
                <a [routerLink]="['/admin/syllabus/index']" class="btn btn-primary me-3">
                    <i class="fa fa-list"></i>  Syllabus List
                  </a>
                  <a [routerLink]="['/admin/syllabus/duplicate',syllabus.server_syllabus_id]" class="btn btn-primary me-3">
                    <i class="fa fa-list"></i>  Duplicate Syllabus
                  </a>
                <button  class="btn btn-primary me-2" (click)="addNewTopicPopUp()">Add New Topic</button>
                <button  class="btn btn-primary me-2" (click)="testSyllabus()">Test Syllabus</button>
            </fieldset>
        </div>
    </div>


    <app-spinner *ngIf="loading"> </app-spinner>



